// extracted by mini-css-extract-plugin
export var createdDate = "_n8-1";
export var divider = "_n8-2";
export var headerDivider = "_n8-3";
export var messagesCard = "_n8-0";
export var messagesContainer = "_n8-6";
export var messagesContainerWrapper = "_n8-4";
export var showLeftPanelButton = "_n8-8";
export var topButtons = "_n8-7";
export var withPadding = "_n8-5";